import './ColumnsRow.css'
import React from 'react'

import Link from './Link'
import Content from './Content'

export default ({ title, description, buttonText, buttonUrl, video, className }) =>
    <section className={`columns-row ${className}`}>
        <div className='container'>
            <div className='content-column'>
                {title && <h2>{title}</h2>}
                {description && <Content src={description} />}
                {buttonText && buttonUrl && <Link className='button' to={buttonUrl}>{buttonText}</Link>}
            </div>
            {video && video.publicURL && 
                <video playsInline autoPlay loop muted>
                    <source src={video.publicURL} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            }
        </div>
    </section>


// WEBPACK FOOTER //
// ./src/components/ColumnsRow.js